import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Form, Container, Button, FormGroup, Alert } from "react-bootstrap";
import { connect } from "react-redux";
import { isEmpty, isNull, upperCase } from "lodash";
import Spinner from 'react-bootstrap/Spinner';
import MaterialTable from 'material-table';
import 'jspdf-autotable';
import { GetHRDesignation, deleteDesignation, updateHRDesignation } from "./HRDetails.actions";
import Select from 'react-select';
import Swal from 'sweetalert';
import { setHeading } from "../../../accounts/account.actions";
import { baseURL, headers } from "../../../../../global/api";


const DesignationList = (props) => {
    const designationData = props.designationList.reverse();
    const tableRef = useRef();
    function updateTableQuery() {
      tableRef.current.onQueryChange()
    };
  
    useEffect(() => {
        props.setHeading("Designation List")
        // props.GetHRDesignation();
    }, []);
    return (
        <>
            {(props.isFetchingDepartmentData ) ? (
                <div className="loader-div">
                    <Button variant="info" disabled>
                        <Spinner
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            variant="info"
                        />
                        {/* {props.isFetchingwareHouseList ? 'Loading...' : 'Loading...'} */}

                    </Button>
                </div>
            ) : (
                <Container fluid>

                            <MaterialTable
                                    title="Designation"
                                    tableRef={tableRef}
                                    columns={ [
                                        { title: 'Division Name', field: 'divisionDetails.name', editable: 'never' },
                                        { title: 'Department Name', field: 'departmentDetails.department', editable: 'never'  },
                                        // {title:"Designation Id",field:'designation_id',render:rowData =>(rowData.division_id+"-"+rowData.department_id+"-"+rowData.designation_id)},
                                        { title: 'Designation Name', field: 'designation' },
                                        { title: 'Designation Description', field: 'description' },
                                        
                                        
                                    ]}
                                    // data={designationData}
                                    data={(query) =>
                                        new Promise((resolve, reject) => {
                                          let url = `${baseURL}/designation?`;
                                          url += "limit=" + query.pageSize;
                                          url += "&page=" + query.page;
                                          url += "&search=" + query.search;
                                          fetch(url, {
                                            method: "GET",
                                            headers: headers,
                                          })
                                            .then((response) => response.json())
                                            .then((result) => {
                                              resolve({
                                                data: result.data,
                                                page: result.page,
                                                totalCount: result.total_results,
                                              });
                                            });
                                        })
                                      }
                                    options={{
                                        actionsColumnIndex: -1,
                                        filtering: false,
                                        exportButton: true,
                                        exportAllData: true,
                                        sorting: true,
                                        paging: true,
                                        pageSize: 50, // make initial page size
                                        emptyRowsWhenPaging: false, // To avoid of having empty rows
                                        pageSizeOptions: [50, 100, 150, 200,500], // rows selection options
                                        headerStyle: {
                                            position: 'sticky', top: 0,
                                            color: '#00BBBB',
                                            fontWeight: '550',
                                            onRowAdd: 'none',
                                        },

                                    }}
                                    editable={{
                                        onRowUpdate: (newData, oldData) =>
                                            new Promise((resolve) => {
                                                setTimeout(() => {
                                                    resolve();
                                                    {
                                                        props.updateHRDesignation(newData, oldData,updateTableQuery)
                                                    }
                                                }, 600);
                                            }),
                                        onRowDelete: (oldData) =>
                                            new Promise((resolve) => {
                                                setTimeout(() => {
                                                    resolve();
                                                    props.deleteDesignation(oldData._id,updateTableQuery);
                                                    console.log(oldData, 'old')
                                                }, 600);
                                            }),
                                    }}
                                />

                </Container>

            )}
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        GetHRDesignation: () => dispatch(GetHRDesignation()),
        deleteDesignation: (designation_id,updateTableQuery) => dispatch(deleteDesignation(designation_id,updateTableQuery)),
        updateHRDesignation: (newData, oldData,updateTableQuery) => dispatch(updateHRDesignation(newData, oldData,updateTableQuery)),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    designationList: state.HrReducer.designationList,
    departmentList: state.HrReducer.departmentList,
    isFetchingDepartmentData: state.HrReducer.isFetchingDepartmentData,
    isFetchingDesignationList: state.HrReducer.isFetchingDesignationList,
    
    

});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DesignationList);